import React from "react";
import { Container, Stack } from "react-bootstrap";
import { Link } from "react-router-dom";

import { useAppSelector } from "@hooks/reduxHooks";

const Grid = (): React.JSX.Element => {
    const { leagues } = useAppSelector(state => state.leaguemanagement);

    return (
        <Container className="leagues" data-testid="leaguesContent">
            {Array.from(
                new Set(leagues.flatMap(l => (l.season ? l.season : ""))),
            ).map((season, idx) => (
                <>
                    <h3 className="d-block" key={idx}>
                        {season}
                    </h3>
                    <Stack
                        className="leaguesGrid mb-4"
                        gap={3}
                        direction="horizontal"
                    >
                        {leagues
                            .filter(l => l.season === season)
                            .map((l, idx) => (
                                <div key={idx}>
                                    <Link to={`/leagues/${l.id}`}>
                                        <h5>
                                            {l.ageLevel}
                                            {l.designation
                                                ? ` ${l.designation}`
                                                : ""}
                                            {l.direction
                                                ? ` ${l.direction}`
                                                : ""}
                                        </h5>
                                    </Link>
                                </div>
                            ))}
                    </Stack>
                </>
            ))}
        </Container>
    );
};

export default Grid;
